/**
 * Converte um nome para as iniciais do avatar.
 */
export function toAvatarInitialsFromName(name) {
  const normalized = String(name ?? "").trim();
  if (!normalized) return "US";
  const parts = normalized.split(/\s+/).filter(Boolean);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0] ?? ""}${parts[1][0] ?? ""}`.toUpperCase();
}
